import { render, staticRenderFns } from "./ProductNewsCard.vue?vue&type=template&id=48e58956"
import script from "./ProductNewsCard.vue?vue&type=script&lang=js"
export * from "./ProductNewsCard.vue?vue&type=script&lang=js"
import style0 from "./ProductNewsCard.vue?vue&type=style&index=0&id=48e58956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports